module.exports = __webpack_public_path__ + "static/backgroundMain-4cfcdc183bc4b638fbb4745c0f065cae.png";